import api from './axiosInstance';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// ── In-app notifications (tenant reads own bell) ──────────────────────────
export const notificationsApi = {
  /** Get latest 50 notifications + unread count for current tenant. */
  getAll:      ()   => api.get('/notifications').then(r => r.data),

  /** Mark a single notification as read. */
  markRead:    (id) => api.post(`/notifications/${id}/read`).then(r => r.data),

  /** Mark all notifications as read. */
  markAllRead: ()   => api.post('/notifications/read-all').then(r => r.data),

  /**
   * Open an SSE stream. Returns an EventSource that fires 'notification' events.
   * Caller must call .close() on cleanup.
   * Needs the Bearer token in the URL because EventSource doesn't support custom headers.
   */
  openStream: (accessToken) => {
    const url = `${BASE_URL}/notifications/stream?token=${encodeURIComponent(accessToken)}`;
    return new EventSource(url, { withCredentials: true });
  },
};

// ── Renewal requests (tenant self-service plan renewal) ───────────────────
export const renewalApi = {
  /** Tenant submits a renewal request with transaction reference. */
  submit: (body) => api.post('/renewals', body).then(r => r.data),

  /** Tenant views their own renewal history. */
  getMy: () => api.get('/renewals/my').then(r => r.data),

  /** Fetch super-admin's public UPI payment details (no auth). */
  getPaymentSettings: () => api.get('/public/system/payment-settings').then(r => r.data),

  // ── Super-admin ──────────────────────────────────────────────────────────

  /** List all renewal requests (super-admin). */
  getAll: (params) => api.get('/super-admin/renewals', { params }).then(r => r.data),

  /** Approve or reject a renewal (super-admin). */
  review: (renewalId, body) =>
    api.post(`/super-admin/renewals/${renewalId}/review`, body).then(r => r.data),

  /** Get super-admin's own UPI settings. */
  getSystemSettings: () =>
    api.get('/super-admin/system/payment-settings').then(r => r.data),

  /** Update super-admin's own UPI settings. */
  updateSystemSettings: (body) =>
    api.patch('/super-admin/system/payment-settings', body).then(r => r.data),

  /** Super-admin pushes an ad-hoc notification to a tenant. */
  sendNotification: (tenantId, body) =>
    api.post(`/super-admin/tenants/${tenantId}/notifications`, body).then(r => r.data),

  /** Broadcast the same notification to ALL active tenants at once. Returns { sent: N }. */
  broadcastAll: (body) =>
    api.post('/super-admin/notifications/broadcast', body).then(r => r.data),
};

// ── Tenant-facing: pending due check ─────────────────────────────────────────
export const subscriptionApi = {
  getRenewalPlans: () => api.get('/subscription/plans').then(r => r.data),
  /** Returns pending due amount if super admin extended subscription on credit. */
  getPendingDue: () => api.get('/subscription/pending-due').then(r => r.data),

  /**
   * Tenant has paid outstanding balance as a standalone transfer.
   * Notifies super admin to verify and record it.
   * body: { amount, transactionRef, paymentMethod }
   */
  payOutstanding: (body) => api.post('/subscription/pay-outstanding', body).then(r => r.data),
};
